/* ============================================
   BeeLive Studio — bee-produits-lies.js — 25/09/2026 (v3 : univers et série lus dans les métachamps)
   Moteur UNIQUE des « Produits liés ».
   Utilisé par sections/bee-produits-lies.liquid (fiche produit, panier,
   article, accueil…) et, plus tard, par le configurateur.
   ⚠️ Toute règle de sélection se change ICI et nulle part ailleurs.
   ⚠️ En revanche l'univers et la série d'un produit ne se saisissent PLUS
      ici : ils viennent des métachamps custom.univers et custom.serie,
      remplis dans l'app catalogue et poussés par le CSV. Les tables UNIVERS
      et SERIES plus bas ne sont qu'un filet pour les produits pas encore
      renseignés. Ajouter une plaque ne demande donc plus de toucher ce fichier.

   API publique : window.beeProduitsLies
     .charger()                        → Promise<catalogue> (une seule requête par page)
     .calculer(sources, opts)          → [{ p, score, pourquoi }]
         sources : handles ou produits du catalogue
         opts    : { limite, profils:[…], exclure:[handles], sansSeries, parSource }
                   parSource  : true → au moins une suggestion par source (panier)
                   sansSeries : true → aucune plaque de porte ni autocollant à
                   l'unité (le configurateur les génère lui-même)
     .universDe(handle) / .famille(code) / UNIVERS / POIDS

   Débogage : ajouter ?bee_pl_debug=1 à l'URL affiche le score sous chaque carte.
   ============================================ */
(function () {
  'use strict';
  if (window.beeProduitsLies) return; // déjà chargé par une autre instance de la section

  /* ── Univers d'usage — FILET uniquement ──
     Ne sert qu'aux produits dont le métachamp custom.univers est vide.
     Un produit renseigné dans l'app ignore complètement cette table ; il n'y
     a donc plus rien à ajouter ici pour une nouvelle plaque.
     (appariement par handle, * = préfixe ; table validée par jg le 21/09) */
  const UNIVERS = {
    'Cuisine': ['cuisine', 'la-cuisine', 'frigo', 'entretien-frigo', 'entretien-four', 'micro-ondes', 'hotte', 'evier', 'plaque-de-cuisson', 'entretien-lave-vaisselle', 'machine-a-cafe', 'machine-a-cafe-entretien', 'torchons', 'pictogrammes-cuisine', 'pictogramme-*', 'poubelles', 'sauvons-la-planete-tri', 'tableau-taches-communes-*', 'rangements', 'salle-a-manger'],
    'Linge': ['buanderie', 'la-buanderie', 'machine-a-laver', 'entretien-lave-linge', 'entretien-seche-linge'],
    'Sanitaires': ['toilettes*', 'vestiaires-*'],
    'Chambres & numéros': ['porte-numero-*', 'numero-*'],
    'Bien-être & loisirs': ['spa', 'sauna', 'piscine', 'espace-bien-etre', 'cinema', 'billard', 'bar', 'salon', 'cave-a-vin', 'barbecue', 'enceintes'],
    'Espaces pro': ['bureaux', 'salle-de-reunion', 'accueil', 'salle-dattente', 'espace_coworking', 'atelier', 'entrepot', 'stockage', 'local-technique', 'acces-reserve'],
    'Sécurité & circulation': ['video-surveillance', 'espace_sous_video-surveillance', 'site_place_sous_alarme_24h-24', 'antivol', 'interdit-fumer*', 'sortie', 'escalier', 'ascenseur', 'local-a-velos'],
    'Portes & accès': ['sonnez-et-entrez', 'appuyez-pour-ouvrir', 'tirez', 'poussez', 'fermez-la-porte'],
    'Éco-gestes & règles': ['sauvons-la-planete*', 'recyclage-papier', 'aerez', 'les-regles-dor', 'informations', 'depart-et-services', 'chaussures', 'be-happy', 'bonne-journee', 'organisation-et-conduite', 'tableau-taches-communes-*']
  };

  /* ── Univers d'un ARTICLE, déduit de mots de son handle ──
     Un article n'a pas de produit source : ces mots lui donnent un ou
     plusieurs univers, pour que ses suggestions suivent son sujet. */
  const MOTS_UNIVERS = [ // mots entiers du handle (entre tirets)
    [/(^|-)(cuisine|taches)(-|$)/, ['Cuisine']],
    [/(^|-)(numeroter|numeros?|chambres?)(-|$)/, ['Chambres & numéros']],
    [/(^|-)(instructions?|modes?|entretiens?)(-|$)/, ['Linge', 'Cuisine', 'Portes & accès']],
    [/(^|-)(regles?)(-|$)/, ['Éco-gestes & règles']],
    [/(^|-)(securite|surveillance)(-|$)/, ['Sécurité & circulation']],
    [/(^|-)(bureaux?|entreprises?|coworking|artisans?|commerces?|ateliers?)(-|$)/, ['Espaces pro']],
    [/(^|-)(buanderie|linge)(-|$)/, ['Linge']],
    [/(^|-)(spa|piscine|loisirs?|bien-etre)(-|$)/, ['Bien-être & loisirs']]
  ];
  function universArticle(handle) {
    const h = String(handle || ''), out = [];
    MOTS_UNIVERS.forEach(([re, us]) => { if (re.test(h)) us.forEach(u => { if (out.indexOf(u) === -1) out.push(u); }); });
    return out;
  }

  /* ── Poids du score ── */
  const POIDS = {
    manuel: 1000,        // listé dans custom.produits_lies de la source : toujours en tête
    univers: 20,         // même univers d'usage qu'une source
    universSourceSup: 5, // panier : +5 par source supplémentaire du même univers
    profil: 3,           // par tag de profil commun (Coloc, Gite, Airbnb, Pro)
    specificite: 4,      // × part des profils du candidat qui sont ceux demandés :
                         // un produit « Pro seulement » passe devant un produit « tous profils »
                         // sur une page Pro
    kit: 6               // kit proposé quand la source est une signalétique seule
  };

  /* Séries à l'unité — FILET uniquement, même principe que UNIVERS :
     un produit dont custom.serie est rempli ignore cette table.
     (demande jg du 21/09) : un seul représentant par série
     dans une sélection, et aucun si la source en fait déjà partie.
     Numéros et pictogrammes à l'unité forment UNE seule série : sur un
     autocollant n°5, on ne propose ni n°6 ni un pictogramme à l'unité.
     Les rouleaux (-AR) ne sont pas concernés. */
  const SERIES = {
    'PPM-90155': 'Plaques de porte',
    'PPM-3030N-AU': 'Autocollants à l\'unité',
    'PPM-3030P-AU': 'Autocollants à l\'unité',
    'PPVEL-TTC': 'Tableaux des tâches communes' // le même tableau en 3 tailles
  };
  const MAX_PAR_SERIE = 1;
  const serieDe = code => SERIES[famille(code)] || null;
  /* La série d'un produit : ce qu'il déclare, sinon ce que son code laisse
     deviner. C'est cette fonction-là qu'utilise la sélection, jamais serieDe. */
  const serieProduit = p => (p && p.serie) || serieDe(p && p.code);
  const PROFILS = ['Coloc', 'Gite', 'Airbnb', 'Pro'];
  const EXCLUS_TOUJOURS = ['signaletique-personnalisee'];

  const matchPat = (h, p) => p.endsWith('*') ? h.startsWith(p.slice(0, -1)) : h === p;

  /* ── Ce que le produit déclare lui-même ──
     BEE_PL_META, émis par sections/bee-produits-lies.liquid, porte pour chaque
     handle : [description courte, choix manuels, univers, série]. Les deux
     derniers viennent de custom.univers et custom.serie. Champ vide → on
     retombe sur les tables ci-dessus, donc le comportement d'avant, produit
     par produit : la bascule peut se faire au fil de l'eau. */
  const metaDe = h => (window.BEE_PL_META || {})[h] || [];
  const listeMeta = v => String(v || '').split(',').map(x => x.trim()).filter(Boolean);

  const universCache = {};
  function universDe(h) {
    const declares = listeMeta(metaDe(h)[2]);
    if (declares.length) return declares;
    if (!universCache[h]) universCache[h] = Object.keys(UNIVERS).filter(u => UNIVERS[u].some(p => matchPat(h, p)));
    return universCache[h];
  }
  /* Famille de format = code interne sans ses segments numériques.
     PPM-90155-5 → PPM-90155 · PPM-3030N-5-AU → PPM-3030N-AU · PPM-3030N-1-AR → PPM-3030N-AR
     PPM-KIT-H → PPM-KIT · PPVEL-TTC-950550-15 → PPVEL-TTC */
  function famille(code) {
    const s = String(code || '').split('-');
    if (s[1] === 'KIT') return 'PPM-KIT';
    if (s[1] === 'TTC') return 'PPVEL-TTC';
    return s.filter((x, i) => i < 2 || !/^\d+$/.test(x)).join('-');
  }
  const estKit = p => /-KIT-/.test(p.code);

  /* Tirage stable pour la visite (beeSessionRandom, assets/bee-lightbox.js) */
  function tirage(cle) { // cle : contexte de la page + handle → l'ordre change d'une page à l'autre
    if (typeof window.beeSessionRandom === 'function') return window.beeSessionRandom('pl|' + cle)();
    return Math.random();
  }

  /* ── Catalogue : /collections/all/products.json + méta émises par la section ── */
  let promesse = null;
  function charger() {
    if (promesse) return promesse;
    promesse = fetch('/collections/all/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(data => {
        const meta = window.BEE_PL_META || {};
        const courtes = window.BEE_SHORT_DESC || {}; // configurateur : pas de BEE_PL_META sur sa page
        const liste = (data.products || [])
          .filter(p => p.variants && p.variants.length && EXCLUS_TOUJOURS.indexOf(p.handle) === -1)
          .map(p => {
            const m = meta[p.handle] || [];
            return {
              handle: p.handle,
              title: p.title,
              code: p.product_type || '',
              profils: (p.tags || []).filter(t => PROFILS.indexOf(t) !== -1),
              images: (p.images || []).map(i => i.src),
              variants: p.variants.map(v => ({ id: v.id, title: v.title, price: parseFloat(v.price) })),
              shortDesc: m[0] || courtes[p.handle] || '',
              manuels: m[1] || [],
              serie: m[3] || ''
            };
          });
        const parHandle = {};
        liste.forEach(p => { parHandle[p.handle] = p; });
        return { liste, parHandle };
      })
      .catch(err => { console.warn('BEE produits liés :', err); promesse = null; return { liste: [], parHandle: {} }; });
    return promesse;
  }

  /* ── Le calcul ── */
  function calculer(catalogue, sources, opts) {
    opts = opts || {};
    const lim = opts.limite || 4;
    sources = (sources || []).map(s => typeof s === 'string' ? catalogue.parHandle[s] : s).filter(Boolean);
    const exclu = new Set((opts.exclure || []).concat(sources.map(s => s.handle)));
    const profilsSrc = new Set(opts.profils && opts.profils.length ? opts.profils : [].concat(...sources.map(s => s.profils)));
    const plaqueSeule = !sources.length || sources.some(s => !estKit(s));
    const manuels = new Set([].concat(...sources.map(s => s.manuels || [])));
    const universSrc = sources.map(s => universDe(s.handle));
    if (opts.univers && opts.univers.length) universSrc.push(opts.univers); // univers d'un article
    const cle = opts.cle || sources.map(s => s.handle).join(',');
    const parSource = !!opts.parSource && sources.length > 1;

    const seriesSrc = new Set(sources.map(serieProduit).filter(Boolean));
    const cands = catalogue.liste.filter(p => {
      if (exclu.has(p.handle)) return false;
      const se = serieProduit(p);
      return !(se && (opts.sansSeries || seriesSrc.has(se)));
    }).map(p => {
      let score = 0;
      const pourquoi = [];
      if (manuels.has(p.handle)) { score += POIDS.manuel; pourquoi.push(['Choix manuel', POIDS.manuel]); }

      const uc = universDe(p.handle);
      const idxTouchees = [];
      universSrc.forEach((us, i) => { if (us.some(u => uc.indexOf(u) !== -1)) idxTouchees.push(i); });
      const touchees = idxTouchees.map(i => universSrc[i]);
      if (touchees.length) {
        const pts = POIDS.univers + POIDS.universSourceSup * (touchees.length - 1);
        const nom = uc.find(u => touchees.some(us => us.indexOf(u) !== -1));
        score += pts;
        pourquoi.push(['Univers ' + nom + (touchees.length > 1 ? ' ×' + touchees.length : ''), pts]);
      }

      const pc = p.profils.filter(x => profilsSrc.has(x));
      if (pc.length) {
        const pts = Math.round(POIDS.profil * pc.length + POIDS.specificite * pc.length / p.profils.length);
        score += pts;
        pourquoi.push(['Profil ' + pc.join(', '), pts]);
      }
      if (estKit(p) && plaqueSeule && pc.length) { score += POIDS.kit; pourquoi.push(['Kit', POIDS.kit]); }

      return { p, score, pourquoi, r: tirage(cle + '|' + p.handle), idx: idxTouchees, profilOk: pc.length > 0 };
    }).filter(c => c.score > 0).sort((a, b) => b.score - a.score || b.r - a.r);

    /* Sélection finale, par ordre de priorité :
       1. choix manuels (custom.produits_lies de la source) ;
       2. le kit le mieux assorti au profil, toujours présent quand il existe (demande jg) ;
       3. panier : au moins une suggestion pour chaque article (opts.parSource) ;
       4. le reste, par score.
       Seule limite par format : 1 produit par série à l'unité (SERIES). */
    const out = [], pris = new Set(), parSerie = {};
    function prendre(c) {
      if (!c || out.length >= lim || pris.has(c.p.handle)) return;
      const se = serieProduit(c.p);
      if (se && (parSerie[se] || 0) >= MAX_PAR_SERIE) return;
      if (se) parSerie[se] = (parSerie[se] || 0) + 1;
      pris.add(c.p.handle);
      out.push(c);
    }
    cands.filter(c => manuels.has(c.p.handle)).forEach(prendre);
    // Un emplacement réservé au kit le mieux assorti ; l'autre kit peut encore
    // venir par son score. Deux kits réservés prendraient toute la place sur mobile.
    prendre(cands.find(c => estKit(c.p) && c.profilOk));
    if (parSource) {
      sources.forEach((s, i) => prendre(cands.find(c => !pris.has(c.p.handle) && c.idx.indexOf(i) !== -1
        && !(serieProduit(c.p) && (parSerie[serieProduit(c.p)] || 0) >= MAX_PAR_SERIE))));
    }
    cands.forEach(prendre);
    return out;
  }

  /* ── Rendu d'une section ── */
  const DEBUG = /[?&]bee_pl_debug=1/.test(location.search);

  function panierActuel() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(r => r.json()).catch(() => ({ items: [] }));
  }

  const estMobile = () => window.matchMedia('(max-width: 749px)').matches;

  /* Combien de cartes tiennent sur une ligne. Mesuré sur le conteneur de la
     section (la section elle-même est masquée tant qu'elle est vide, donc
     sans largeur). Même calcul que le CSS : cartes fixes + espaces de 16 px. */
  function parLigne(root, cfg) {
    if (estMobile()) return 2;
    const hote = root.parentElement || document.body;
    const max = cfg.largeur === 'pleine' ? Infinity : (cfg.largeurPx || 1200);
    const dispo = Math.min(hote.clientWidth || window.innerWidth, max) - 48; // padding 1.5rem × 2
    const w = cfg.carte || 270, gap = cfg.gap || 16;
    return Math.max(1, Math.floor((dispo + gap) / (w + gap)));
  }
  function limiteDe(root, cfg) {
    const max = cfg.limite || 4;
    if (cfg.mode !== 'lignes') return max;
    // Lignes complètes : jamais plus que le maximum réglé, jamais plus que ce qui tient.
    return Math.min(max, parLigne(root, cfg) * (cfg.lignes || 1));
  }

  function rendre(root) {
    const cfg = JSON.parse(root.getAttribute('data-config') || '{}');
    root._beePlLimite = limiteDe(root, cfg);
    const grid = root.querySelector('.bee-pl__grid');
    if (!grid || typeof window.beeBuildPcard !== 'function') return;

    Promise.all([charger(), panierActuel()]).then(([cat, cart]) => {
      const auPanier = (cart.items || []).map(i => i.handle);
      let sources = [], profils = [];
      let exclure = auPanier, parSource = false, universPage = [], clePage = '';
      if (cfg.source === 'cart') { sources = auPanier; parSource = true; }
      else if (cfg.source === 'product') sources = [cfg.handle];
      else if (cfg.source === 'collection') {
        /* Collection de profil (Coloc, Gite…) : elle affiche déjà tout le profil,
           on met en avant les kits et le profil. Collection par type : on
           propose ce qui va avec ses produits, hors produits déjà affichés. */
        if (cfg.profilTag) profils = [cfg.profilTag];
        else { sources = cfg.handles || []; exclure = auPanier.concat(sources); }
      }
      else {
        /* Article : tous portent « all » ; seuls les tags de profil précis
           (gite, coloc, airbnb, pro) comptent. « all » seul (articles
           « conseil ») → tous les profils. */
        const tags = (Array.isArray(cfg.tags) ? cfg.tags : []).map(x => String(x).toLowerCase());
        profils = PROFILS.filter(pr => tags.indexOf(pr.toLowerCase()) !== -1);
        if (!profils.length) profils = PROFILS.slice();
        universPage = universArticle(cfg.handle);
        clePage = 'article:' + (cfg.handle || '') + ':' + tags.join(',');
      }

      if (cfg.source === 'collection') clePage = 'collection:' + (cfg.profilTag || (cfg.handles || []).length);
      /* offset : décale la fenêtre dans la sélection, pour qu'un second bloc sur
         la même page n'affiche pas les mêmes produits que le premier. Absent =
         comportement inchangé pour tous les autres usages du script. */
      const off = Math.max(0, parseInt(cfg.offset, 10) || 0);
      const res = calculer(cat, sources, { limite: root._beePlLimite + off, profils, exclure, parSource, univers: universPage, cle: clePage }).slice(off);
      if (!res.length) {
        root.classList.add('bee-pl--vide');
        grid.innerHTML = '';
        return;
      }
      grid.innerHTML = res.map(c => {
        const p = c.p;
        let html = window.beeBuildPcard({
          title: p.title, handle: p.handle, images: p.images.slice(0, 3),
          shortDesc: p.shortDesc, variants: p.variants
        });
        if (DEBUG) {
          html = html.replace(/<\/div>\s*$/, '<div class="bee-pl__debug"><b>' + c.score + ' pts</b> · '
            + c.pourquoi.map(x => x[0] + ' +' + x[1]).join(' · ') + ' · ' + famille(p.code)
            + (listeMeta(metaDe(p.handle)[2]).length ? ' · univers : métachamp' : ' · univers : table')
            + '</div></div>');
        }
        return '<div class="bee-pl__item">' + html + '</div>';
      }).join('');
      root.classList.remove('bee-pl--vide');
    });
  }

  function init() {
    document.querySelectorAll('.bee-pl[data-config]').forEach(rendre);
  }

  /* Panier : la sélection suit le contenu du panier, avec un délai pour laisser
     le bouton afficher « ✓ Ajouté ! » avant que la carte ne soit remplacée. */
  let delai = null;
  document.addEventListener('cart:update', function () {
    const roots = document.querySelectorAll('.bee-pl[data-source="cart"]');
    if (!roots.length) return;
    clearTimeout(delai);
    delai = setTimeout(() => roots.forEach(rendre), 1900);
  });

  /* Mode « lignes complètes » : on recalcule quand le nombre de cartes par
     ligne change (rotation, fenêtre redimensionnée). Le tirage étant stable,
     les premières cartes restent les mêmes, on en ajoute ou on en retire. */
  let delaiResize = null;
  window.addEventListener('resize', function () {
    clearTimeout(delaiResize);
    delaiResize = setTimeout(() => {
      document.querySelectorAll('.bee-pl[data-config]').forEach(root => {
        const cfg = JSON.parse(root.getAttribute('data-config') || '{}');
        if (cfg.mode === 'lignes' && limiteDe(root, cfg) !== root._beePlLimite) rendre(root);
      });
    }, 250);
  });

  /* Éditeur de thème : re-rendu quand la section est ajoutée ou modifiée */
  document.addEventListener('shopify:section:load', function (e) {
    const root = e.target.querySelector('.bee-pl[data-config]');
    if (root) rendre(root);
  });

  window.beeProduitsLies = {
    charger,
    calculer: (sources, opts) => charger().then(cat => calculer(cat, sources, opts)),
    universDe, universArticle, famille, serieDe, serieProduit, UNIVERS, POIDS, SERIES
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();